import { RoundedModal } from "@/components/modal/rounded-modal";
import { FilledButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface FavouriteBrandsModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const FavouriteBrandsModal = memo(function FavouriteBrandsModal({
  isOpen,
  onDismiss,
  onConfirm,
}: FavouriteBrandsModalProps) {
  return (
    <RoundedModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      backdropDismiss={true}
      maxWidth="300px"
    >
      <div className="flex flex-col items-center p-4 pt-0">
        <h2 className={cn(textVariants.title3, "text-center mb-[10px] mt-8")}>
          It's all ok!
        </h2>

        <p className={cn(textVariants.body, "mb-6 text-center")}>
          ALL of these brands are already available for your plan!
        </p>

        <div className="w-full">
          <FilledButton text="OK" color="black" onClick={onConfirm} />
        </div>
      </div>
    </RoundedModal>
  );
});
